import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { DpadZoneType, Mode } from '@core/constants';
import { LocalStorageService } from '@core/services/common';
import { DpadControlService } from '@core/services/common/dpad-control.service';

@Component({
  selector: 'caremoni-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges, AfterViewInit {
  @Input() hideResync: boolean = false;
  @Input() hideLock: boolean = false;
  @Input() hidePaging: boolean = false;
  @Input() hideSetting: boolean = false;
  @Input() isSyncData: boolean = false;
  @Input() isLocked: boolean = false;
  @Input() currentPage: number = 1;
  @Input() totalPage: number = 1;
  @Input() pageNumberCount: number = 6;
  @Input() dpadY: number = 0;
  @Input() dpadScale: number = 1.3;
  @Output() pageChange = new EventEmitter<number>();
  @Output() onClickReloadButton = new EventEmitter<void>();
  @Output() onClickSetting = new EventEmitter<void>();
  @Output() onClickLockButton = new EventEmitter<any>();

  @ViewChild('paginationWrapper', { static: false }) paginationWrapper!: ElementRef;

  DpadZoneType = DpadZoneType;
  pageNumbers: (number | null)[] = [];
  private isUserAction = false;
  dpadXLockBtn: number = 1;

  constructor(
    private localStorageService : LocalStorageService,
    private dpadControlService: DpadControlService,
  ){}

  ngOnInit(): void{
    const mode = this.localStorageService.getItem(LOCAL_STORAGE_KEY.mode)
    if(mode == Mode.TV) this.hideSetting = true;
    this.updateLockButtonDpadX();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentPage'] || changes['totalPage'] || changes['pageNumberCount']) {
      this.updatePageNumbers();
      if (this.isUserAction) {
        this.updateDpadOnUserAction();
      } else {
        this.updateDpadOnAutoChange();
      }
      // reset lại flag
      this.isUserAction = false;
      this.updateLockButtonDpadX();
    }
  }

  ngAfterViewInit(): void {
    this.updatePageNumbers();
    setTimeout(() => { this.dpadControlService.initScreen({moveType: 1, dYMax: DpadZoneType.MAIN}) });
  }

  async selectPage(page: number | null): Promise<void> {
    if (page !== null && page !== this.currentPage) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
      // isUserAction để phân biệt phân trang tự động hay phân trang do user thao tác.
      this.isUserAction = true;
    }
  }

  private updateDpadOnUserAction(): void {
    if (this.dpadControlService.currentZoneType === DpadZoneType.SCREEN) {
      if (this.currentPage === 1) return;
      const idx = this.pageNumbers.findIndex(p => p === this.currentPage);
      if (idx !== -1) {
        const x = this.hideResync ? idx + 1 : idx;
        this.dpadControlService.selectDpadX = x;
        this.resetDpadItem();
      }
    }
  }

  updateLockButtonDpadX(): void {
    const visiblePages = this.pageNumbers.filter(p => p !== null).length;
    const x = visiblePages + 1;
    this.dpadXLockBtn = x;
  }

  private updateDpadOnAutoChange(): void {
    if (this.dpadControlService.currentZoneType === DpadZoneType.SCREEN){
      this.resetDpadItem();
    }
  }

  private resetDpadItem(): void {
    setTimeout(() => {
      this.dpadControlService.clearSelectItemDpad();
      this.dpadControlService.selectItemDpad();
    }, 100);
  }

  updatePageNumbers(): void {
    const pageNumberCount = Math.max(this.pageNumberCount || 6, 1);
    const pageOffset = Math.ceil(pageNumberCount / 2) - 1;
    this.pageNumbers = Array(pageNumberCount).fill(null);
    if (this.totalPage <= pageNumberCount) {
      for (let i = 0; i < this.totalPage; i++) {
        this.pageNumbers[i] = i + 1;
      }
    } else {
      let startPage: number;
      if (this.currentPage <= pageOffset + 1) {
        startPage = 1;
      } else if (this.currentPage >= this.totalPage - pageOffset) {
        startPage = this.totalPage - pageNumberCount + 1;
      } else {
        startPage = this.currentPage - pageOffset;
      }
      for (let i = 0; i < pageNumberCount; i++) {
        this.pageNumbers[i] = startPage + i;
      }
    }
    const checkNullAllPage = (this.pageNumbers.every(item => item == null));
    if(checkNullAllPage) this.pageNumbers[0] = 1;
  }

  syncData(): void {
    this.onClickReloadButton.emit();
  }

  clickSetting() {
    this.onClickSetting.emit();
  }

  toggleLock(): void {
    this.isLocked = !this.isLocked;
    this.onClickLockButton.emit(this.isLocked);
  }
}
